<script lang="ts">
  interface Props {
    label: string;
    actionLabel?: string;
    actionLink?: string;
  }

  let { label, actionLabel = '', actionLink = '' }: Props = $props();
</script>

<div data-cy="info-view" class="comp-info-view">
  <div class="message">
    <span class="text">{label}</span>
    {#if actionLabel && actionLink}
      <a class="action-link" href={actionLink}> {actionLabel}</a>
    {/if}
  </div>
</div>

<style>
  .comp-info-view {
    width: 100%;
    height: 150px;
    background-color: var(--grey-bg);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .comp-info-view .message {
    width: 100%;
    color: var(--grey-medium);
    font-style: italic;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .action-link {
    margin-left: 8px;
    color: var(--blue);
    text-decoration: none;
  }
</style>
